import { atom } from 'jotai';

const translationsAtom = atom({ locale: '' });

export { translationsAtom };